import Box from '@material-ui/core/Box';
import BoxList from 'boxList/BoxList';
import BoxListDialog from 'boxList/BoxListDialog';
import Loading from 'components/Loading';
import Map from 'map/Map';
import React from 'react';
import useBoxes from './useBoxes';
import { useLoadGoogleMaps } from './useLoadGoogleMaps';
import useSubBoxStatuses from './useSubBoxStatuses';

interface Props {}

export const BOX_LIST_WIDTH = '330px';

const Home = (props: Props) => {
  const { isLoaded, loadError } = useLoadGoogleMaps();

  const { data, isSuccess } = useBoxes({ enabled: isLoaded });

  const statusIsLoading = useSubBoxStatuses({ enabled: isSuccess });

  if (loadError) return <div>{loadError.message}</div>;

  if (!isSuccess || !isLoaded || !data || statusIsLoading) return <Loading />;

  return (
    <>
      <Box
        display="grid"
        gridTemplateColumns={`1fr ${BOX_LIST_WIDTH}`}
        height="100vh"
      >
        <Map boxes={data.boxes} boxBounds={data.boxBounds} />
        <BoxList boxes={data.boxes} />
      </Box>
      <BoxListDialog />
    </>
  );
};

export default Home;
